/** ExportPostModal — preview of the generated Instagram card with Download +
 *  native Share. */
import React from "react";
import { X, Download, Share2 } from "lucide-react";

const GOLD = "#E2DD9F";

export default function ExportPostModal({ image, onClose }) {
  const download = () => {
    const a = document.createElement("a");
    a.href = image.url; a.download = "bam-coaches-post.png";
    document.body.appendChild(a); a.click(); a.remove();
  };
  const share = async () => {
    try {
      const file = image.blob ? new File([image.blob], "bam-coaches-post.png", { type: "image/png" }) : null;
      if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: "BAM Coaches" });
      } else download();
    } catch { /* user cancelled / unsupported */ }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 10000, background: "rgba(0,0,0,0.8)", backdropFilter: "blur(6px)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ position: "relative", maxWidth: 380, width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        <button onClick={onClose} style={{ position: "absolute", top: -44, right: 0, background: "rgba(255,255,255,0.08)", border: "none", borderRadius: 10, width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#ccc" }}><X size={18} /></button>
        <img src={image.url} alt="Shareable post" style={{ width: "100%", borderRadius: 16, border: "1px solid rgba(226,221,159,0.2)", boxShadow: "0 20px 60px rgba(0,0,0,0.6)" }} />
        <div style={{ display: "flex", gap: 10, width: "100%" }}>
          <button onClick={share} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "13px 0", borderRadius: 12, background: GOLD, color: "#0A0A0A", border: "none", fontWeight: 800, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
            <Share2 size={17} /> Share
          </button>
          <button onClick={download} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "13px 0", borderRadius: 12, background: "rgba(255,255,255,0.08)", color: "#fff", border: "1px solid rgba(255,255,255,0.12)", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
            <Download size={17} /> Download
          </button>
        </div>
        <div style={{ fontSize: 12, color: "#888", textAlign: "center" }}>Save it, then post to your Instagram story or feed.</div>
      </div>
    </div>
  );
}
